import { defineMessages, enPlural, ruPlural } from '@/i18n'

export const messages = defineMessages({
  ru: {
    a11yPagination: 'Страницы',
    a11yPrevPage: 'Предыдущая страница',
    a11yNextPage: 'Следующая страница',
    clearSearch: 'Очистить поиск',
    coursesCount: (n: number) => `${n} ${ruPlural(n, 'курс', 'курса', 'курсов')}`,
    loadFailedTitle: 'Ой, каталог не загрузился…',
    loadFailedHint: 'Проверьте интернет и попробуйте ещё раз.',
    retry: 'Повторить',
    nothingFound: 'Ой, ничего не нашлось…',
    nothingFoundHint: 'Попробуйте другие фильтры или сбросьте их.',
    resetFilters: 'Сбросить фильтры',
    showAllLanguages: 'Показать все языки',
    noPublicCourses: 'На платформе ещё нет публичных курсов',
    noPublicCoursesHint: 'Скоро здесь появятся интересные курсы от авторов',
    searchPlaceholder: 'Поиск курсов...',
  },
  en: {
    a11yPagination: 'Pagination',
    a11yPrevPage: 'Previous page',
    a11yNextPage: 'Next page',
    clearSearch: 'Clear search',
    coursesCount: (n: number) => `${n} ${enPlural(n, 'course', 'courses')}`,
    loadFailedTitle: "Oops, the catalog didn't load…",
    loadFailedHint: 'Check your connection and try again.',
    retry: 'Retry',
    nothingFound: 'Oops, nothing found…',
    nothingFoundHint: 'Try other filters or reset them.',
    resetFilters: 'Reset filters',
    showAllLanguages: 'Show all languages',
    noPublicCourses: 'There are no public courses on the platform yet',
    noPublicCoursesHint: 'Courses from authors will show up here soon',
    searchPlaceholder: 'Search courses…',
  },
})
